import {config} from './hapi.config';

// https://nuxt.com/docs/api/configuration/nuxt-config
export default defineAppConfig({
	host: config[config.default].host,
	lang: config[config.default].lang,
	cache: {
		enabled: config[config.default].apiCache,
	},
	meta: [
		{property: 'og:locale:alternate', content: 'si_SI'},
		{property: 'og:locale:alternate', content: 'hr_HR'},
	],
	catalog: {
		fetch: {
			check_lists: 'webcatalog_cs-fm-ba,webcatalog_cs-lb-ba,webcatalog_cs-lt-ba,webcatalog_3d-ar-ba',
			appconfig: 'product_pim_min_chars',
		},
	},
});
